import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  mobileMenu = false;
  
  
  mobileMenuClicked() {
    if (this.mobileMenu) {
    this.mobileMenu = false;
    } else {
      this.mobileMenu = true;
    }
  }
}



// WEBPACK FOOTER //
// /Users/samirjha/Project/nushing/src/app/app.component.ts